import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { TermsAndConditionsService } from '../../services/terms-and-conditions.service';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'app-terms-text',
    templateUrl: './terms-text.component.html',
    standalone: false
})
export class TermsTextComponent implements OnDestroy {
  text?: string;
  faSpinnerThird = faSpinnerThird;

  private subscription: Subscription;

  constructor(termsAndConditionsService: TermsAndConditionsService) {
    this.subscription = termsAndConditionsService
      .get$()
      .subscribe(x => this.text = x?.termsAndConditions);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
